
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevPathname = useRef(pathname);

  // Enforce manual scroll restoration so browsers do not retain dirty scroll offsets in SPA routing
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    const isDifferentPage = prevPathname.current !== pathname;
    prevPathname.current = pathname;

    const scrollToElement = () => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
      }
      return false;
    };

    if (hash) {
      // 1. Attempt scroll immediately (works if we are already on the page)
      const success = scrollToElement();

      // 2. If element not found (navigating from another page), wait for transition
      if (!success) {
        // We set multiple checkpoints to ensure scroll happens after the 0.5s page transition
        const timers = [
          setTimeout(scrollToElement, 100), // Quick check
          setTimeout(scrollToElement, 600), // After exit animation completes
          setTimeout(scrollToElement, 1200)  // Final fallback
        ];

        return () => timers.forEach(clearTimeout);
      }
    } else {
      // If we navigated to a completely different page, reset scroll instantly
      if (isDifferentPage) {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } else {
        // Same page, cleared hash (e.g. #grow -> "")
        if (pathname.includes('agroscore')) {
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          window.dispatchEvent(new CustomEvent('vexl:agroscore:scrollToOverview'));
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      }
    }
  }, [pathname, hash]);

  return null;
}
